// File name the server chose for a download (Content-Disposition), e.g.
// «Отчёт для родителей — Крекина Дарина — октябрь 2026.pdf».
// Prefers the UTF-8 `filename*`, then plain `filename`, else the fallback.
export function serverFileName(res, fallback) {
  const header =
    (res && res.headers && res.headers.get('Content-Disposition')) || '';
  const star = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header);
  if (star) {
    try {
      return decodeURIComponent(star[1].trim());
    } catch (e) {
      // malformed header → fall through
    }
  }
  const plain = /filename\s*=\s*"([^"]+)"/i.exec(header);
  return plain ? plain[1] : fallback;
}
